import RouteWithPermission from 'components/RouteWithPermission/RouteWithPermission';
import { useCoreContext } from 'contexts/coreContext';
import { RoleNames } from 'core';
import { isRoles } from 'core/permission/PermissionDSL';
import { get } from 'lodash';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { StoredValueList } from './StoredValueList/StoredValueList';
import { StoredValueDetail } from './StoredValueDetail/StoredValueDetail';

export const StoredValue: React.FC = () => {
  const core = useCoreContext();
  const agencyId: number | undefined = get(
    core,
    'accountManager.localeMeta.agencyId'
  );
  return (
    <Switch>
      <Route path={'/stored-value/:agencyId'}>
        <StoredValueDetail />
      </Route>
      <RouteWithPermission
        path={'/stored-value'}
        permissionAware={isRoles(RoleNames.sysAdmin)}
        redirectPath={`/stored-value/${agencyId}`}
      >
        <StoredValueList />
      </RouteWithPermission>
    </Switch>
  );
};
